var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNamesAttract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1556,
    height: 2099,
    viewBox: "0 0 1556 2099",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1419.5 2C2202.31 2 2837 635.953 2837 1417.86C2837 2199.77 2202.31 2833.73 1419.5 2833.73C636.686 2833.73 2 2199.77 2 1417.86C2 635.953 636.686 2 1419.5 2ZM1419.5 355.966C832.301 355.966 356.375 831.342 356.375 1417.86C356.375 2004.38 832.301 2479.76 1419.5 2479.76C2006.7 2479.76 2482.62 2004.38 2482.62 1417.86C2482.62 831.342 2006.7 355.966 1419.5 355.966ZM1419.5 621.44C1859.99 621.44 2216.84 977.884 2216.84 1417.86C2216.84 1857.84 1859.99 2214.29 1419.5 2214.29C979.012 2214.29 622.156 1857.84 622.156 1417.86C622.156 977.884 979.012 621.44 1419.5 621.44ZM1419.5 975.406C1174.98 975.406 976.531 1173.63 976.531 1417.86C976.531 1662.1 1174.98 1860.32 1419.5 1860.32C1664.02 1860.32 1862.47 1662.1 1862.47 1417.86C1862.47 1173.63 1664.02 975.406 1419.5 975.406ZM1419.5 1240.88C1517.31 1240.88 1596.69 1320.17 1596.69 1417.86C1596.69 1515.56 1517.31 1594.85 1419.5 1594.85C1321.69 1594.85 1242.31 1515.56 1242.31 1417.86C1242.31 1320.17 1321.69 1240.88 1419.5 1240.88Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNamesAttract);
export default __webpack_public_path__ + "static/media/names-attract.e9502fbda639c5c9ab3e2ea1216c3ce1.svg";
export { ForwardRef as ReactComponent };